/**
 * useModals - Manages all modal visibility state for DriverApp
 * Extracted to reduce DriverApp.jsx complexity
 */
import { useState } from 'react';

export function useModals() {
  const [showMenu, setShowMenu] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [showJourneyModal, setShowJourneyModal] = useState(false);
  const [showFinishModal, setShowFinishModal] = useState(false);
  const [showNightRestConfirm, setShowNightRestConfirm] = useState(false);
  const [showVehicleModal, setShowVehicleModal] = useState(false);
  const [showOtherVehicleForm, setShowOtherVehicleForm] = useState(false);
  const [showRadiusSelectionModal, setShowRadiusSelectionModal] = useState(false);
  const [showRadiusWarning, setShowRadiusWarning] = useState(false);
  const [showAboutModal, setShowAboutModal] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [showBaseAddressModal, setShowBaseAddressModal] = useState(false);
  const [showOdometerConfirm, setShowOdometerConfirm] = useState(false);
  const [showFuelStopModal, setShowFuelStopModal] = useState(false);
  const [showMyVehicleModal, setShowMyVehicleModal] = useState(false);
  const [showMyDiaryModal, setShowMyDiaryModal] = useState(false);
  const [showReportsModal, setShowReportsModal] = useState(false);
  const [showRestLocationModal, setShowRestLocationModal] = useState(false);
  const [showAcknowledgementModal, setShowAcknowledgementModal] = useState(false);
  const [ackCheckbox, setAckCheckbox] = useState(false);
  const [acknowledgementAccepted, setAcknowledgementAccepted] = useState(() =>
    localStorage.getItem('lawd_driver_acknowledged') === 'true'
  );

  return {
    showMenu, setShowMenu,
    showLogoutConfirm, setShowLogoutConfirm,
    showJourneyModal, setShowJourneyModal,
    showFinishModal, setShowFinishModal,
    showNightRestConfirm, setShowNightRestConfirm,
    showVehicleModal, setShowVehicleModal,
    showOtherVehicleForm, setShowOtherVehicleForm,
    showRadiusSelectionModal, setShowRadiusSelectionModal,
    showRadiusWarning, setShowRadiusWarning,
    showAboutModal, setShowAboutModal,
    showExportModal, setShowExportModal,
    showBaseAddressModal, setShowBaseAddressModal,
    showOdometerConfirm, setShowOdometerConfirm,
    showFuelStopModal, setShowFuelStopModal,
    showMyVehicleModal, setShowMyVehicleModal,
    showMyDiaryModal, setShowMyDiaryModal,
    showReportsModal, setShowReportsModal,
    showRestLocationModal, setShowRestLocationModal,
    showAcknowledgementModal, setShowAcknowledgementModal,
    ackCheckbox, setAckCheckbox,
    acknowledgementAccepted, setAcknowledgementAccepted,
  };
}
